import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import type { Duration, DurationUnitsObjectType } from 'dayjs/plugin/duration';

dayjs.extend(duration);

/**
 * Returns the longest duration among the provided duration objects.
 *
 * @param durations Duration objects to be evaluated (e.g., { hours: 1 }, { minutes: 30 }).
 * @returns The longest duration as a dayjs.Duration object.
 * @throws Error if no durations are provided.
 */
export function maxDuration(...durations: DurationUnitsObjectType[]): Duration {
  if (durations.length === 0) {
    throw new Error('At least one duration is required');
  }

  // Convert to milliseconds and find the max
  const maxMs = Math.max(...durations.map((d) => dayjs.duration(d).asMilliseconds()));

  // Return a new duration from the max milliseconds
  return dayjs.duration({ milliseconds: maxMs });
}
